var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferMilesGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 30.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7d8489;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "transfer_miles_grey") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.06,17.867H13.388l1.789-1.788a.6.6,0,0,0-.849-.849l-2.811,2.811a.6.6,0,0,0-.178.426h0a.6.6,0,0,0,.175.421v0l2.813,2.813a.6.6,0,0,0,.849,0,.6.6,0,0,0,0-.848l-1.79-1.79H20.06a.6.6,0,0,0,0-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.48,23.655l-2.809-2.808a.6.6,0,0,0-.848.848l1.787,1.788H11.939a.6.6,0,1,0,0,1.2h6.674l-1.79,1.79a.6.6,0,1,0,.848.848l2.813-2.812,0,0a.6.6,0,0,0,.174-.418v0h0A.6.6,0,0,0,20.48,23.655Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.551,8.025A5.416,5.416,0,0,0,0,13.281v9.742a.8.8,0,1,0,1.6,0V13.281A3.817,3.817,0,0,1,5.551,9.625,3.816,3.816,0,0,1,9.5,13.281v1.7a.8.8,0,0,0,1.6,0v-1.7A5.416,5.416,0,0,0,5.551,8.025Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.634,20.476a.8.8,0,0,0-.8.8v8.918a.8.8,0,0,0,1.6,0V21.276A.8.8,0,0,0,3.634,20.476Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.468,20.476a.8.8,0,0,0-.8.8v8.918a.8.8,0,0,0,1.6,0V21.276A.8.8,0,0,0,7.468,20.476Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.551,7a3.5,3.5,0,1,0-3.5-3.5A3.5,3.5,0,0,0,5.551,7Zm0-5.395a1.9,1.9,0,1,1-1.9,1.9A1.9,1.9,0,0,1,5.551,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.448,8.025a5.415,5.415,0,0,0-5.55,5.256v1.7a.8.8,0,1,0,1.6,0v-1.7a3.816,3.816,0,0,1,3.95-3.656A3.817,3.817,0,0,1,30.4,13.281v9.742a.8.8,0,0,0,1.6,0V13.281A5.417,5.417,0,0,0,26.448,8.025Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.366,20.476a.8.8,0,0,0-.8.8v8.918a.8.8,0,1,0,1.6,0V21.276A.8.8,0,0,0,28.366,20.476Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.532,20.476a.8.8,0,0,0-.8.8v8.918a.8.8,0,0,0,1.6,0V21.276A.8.8,0,0,0,24.532,20.476Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.448,7a3.5,3.5,0,1,0-3.5-3.5A3.5,3.5,0,0,0,26.448,7Zm0-5.395a1.9,1.9,0,1,1-1.9,1.9A1.9,1.9,0,0,1,26.448,1.6Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferMilesGray);
export default __webpack_public_path__ + "static/media/transfer_miles_gray.a3ecf799a5c374a26b5075c4d0098470.svg";
export { ForwardRef as ReactComponent };